import { useRegisterSW } from "virtual:pwa-register/react";

export interface PwaUpdateState {
  readonly offlineReady: boolean;
  readonly updateAvailable: boolean;
  readonly accept: () => void;
  readonly dismiss: () => void;
}

export const usePwaUpdate = (): PwaUpdateState => {
  const {
    needRefresh: [updateAvailable, setUpdateAvailable],
    offlineReady: [offlineReady, setOfflineReady],
    updateServiceWorker,
  } = useRegisterSW({
    immediate: true,
    onRegisteredSW(_url, registration) {
      if (registration !== undefined)
        setInterval(() => void registration.update(), 60 * 60 * 1000);
    },
  });
  return {
    offlineReady,
    updateAvailable,
    accept: () => {
      void updateServiceWorker(true);
    },
    dismiss: () => {
      setUpdateAvailable(false);
      setOfflineReady(false);
    },
  };
};
